import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=4bdf1ac0&scoped=true"
import script from "./realTime.vue?vue&type=script&lang=js"
export * from "./realTime.vue?vue&type=script&lang=js"
import style0 from "./realTime.vue?vue&type=style&index=0&id=4bdf1ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf1ac0",
  null
  
)

export default component.exports